// extracted by mini-css-extract-plugin
export default {"wrapper":"finance_wrapper__uTFXO","title":"finance_title__6l4wD","header":"finance_header__2IkcN","profileAssign":"finance_profileAssign__rW0xG","btn":"finance_btn__q56y9"};